import { render, staticRenderFns } from "./ClusterizacionView.vue?vue&type=template&id=a6264064&scoped=true"
import script from "./ClusterizacionView.vue?vue&type=script&lang=js"
export * from "./ClusterizacionView.vue?vue&type=script&lang=js"
import style0 from "./ClusterizacionView.vue?vue&type=style&index=0&id=a6264064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6264064",
  null
  
)

export default component.exports